module.exports = __webpack_public_path__ + "static/media/01.15963532.png";